module.exports = __webpack_public_path__ + "components/MapControl/svg/Szlak przyrodniczo-edukacyjny inny.svg?8ab3af2a";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Szlak przyrodniczo-edukacyjny inny.svg
// module id = 2129
// module chunks = 0